/**
 * @file: subjectTypeInfoUtil.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { ServiceSubjectType } from '@euler/model/enum';
type SubjectTypeInfo = {
  bgColor: string;
  textColor: string;
  text: string;
};

export const kSubjectTypeInfoMap: {
  [p in ServiceSubjectType]: SubjectTypeInfo;
} = {
  inspection: {
    bgColor: 'rgba(168, 193, 10, 0.3)',
    textColor: 'rgb(168, 193, 10)',
    text: '车辆检测',
  },
  fault: {
    bgColor: 'rgba(247, 30, 17, 0.22)',
    textColor: 'rgb(255, 79, 69)',
    text: '故障检修',
  },
  construction: {
    bgColor: 'rgba(255, 153, 0, 0.12)',
    textColor: 'rgb(212, 160, 5)',
    text: '维保施工',
  },
  other: {
    bgColor: 'rgba(100, 138, 255, 0.22)',
    textColor: 'rgb(100, 138, 255)',
    text: '其他项目',
  },
};
